import axios from 'axios';
import {V1API} from "../../../_helpers/APIPath";
import {encode, decode} from "../../dataMagic";
import {populateStore, performNetworkCall, buildFormData} from "@/store/asyncHelper";


const keyList = {
    smsUpdate : 'DASHBOARD_UPDATE',
    smsDelete : 'DASHBOARD_DELETE'
};

const mutations = {};
const store = {};

populateStore(store, mutations, keyList, false);

export default {
    namespaced: true,

    state : {
        dashboard_count: {},
        demographic_count:{},
        demographic_count_by_shelter:{},
        dashboard_count_by_shelter:{},
        demographic_count_by_shelter_live:{},
        dashboadr_count_by_shelter_live:{},
        contact_by_shelter:{},
       
        submitSuccess: false,
        submitLoading:false,
        submitError:false,

        dashboardCountLoading: false,
        dashboardCountError: false,
 

        ...store
    },

    mutations : {
        ...mutations,

        SET_DASHBOARD_COUNT(state, shelter) {
            state.dashboard_count = shelter;
        },
        SET_DASHBOARD_DEMOGRAPHIC_COUNT(state, shelter) {
            state.demographic_count = shelter;
        },
        SET_DASHBOARD_COUNT_SHELTER_LIVE(state, shelter) {
            state.dashboadr_count_by_shelter_live = shelter;
        },
        
        SET_DASHBOARD_DEMOGRAPHIC_COUNT_BY_SHELTER(state, shelter) {
            state.demographic_count_by_shelter = shelter;
        },
        SET_DASHBOARD_DEMOGRAPHIC_COUNT_BY_SHELTER_LIVE(state, shelter) {
            state.demographic_count_by_shelter_live = shelter;
        },

        get_contact_list_by_shelter(state, shelter) {
            state.contact_by_shelter = shelter;
        },

        SET_DASHBOARD_COUNT_SHELTER(state, shelter) {
            state.dashboard_count_by_shelter = shelter;
        },
     
        DASHBOARD_COUNT_LOADING (state, loading) {
            state.dashboardCountLoading = loading;
        },

        DASHBOARD_COUNT_ERROR (state, hasError) {
            state.dashboardCountError = hasError;
        },

        SUBMIT_SUCCESS (state, success) {
            state.submitSuccess = success;
        },
        SUBMIT_LOADING (state, loading) {
            state.submitLoading = loading;
        },
        SUBMIT_ERROR (state, hasError) {
            state.submitError = hasError;
        },

       
    },

    actions: {
    
        async fetchDashboardCount ({ commit }) {
            commit('DASHBOARD_COUNT_LOADING', true);
            commit('DASHBOARD_COUNT_ERROR', false);

            let config = {
                headers: {
                  Authorization: "Bearer " + localStorage.getItem("access_token"),
                }
            };

            try {
                let result = await axios.get(V1API.get_dashboard_count, config);
                let response = result.data
                commit('SET_DASHBOARD_COUNT', response.data);

            } catch(error) {
                commit('DASHBOARD_COUNT_ERROR', true);
            } finally {
                commit('DASHBOARD_COUNT_LOADING', false);
            }
        },
        async fetchDashboardDemographicCount ({ commit }) {
            commit('SUBMIT_LOADING', true);
            commit('SUBMIT_ERROR', false);

            let config = {
                headers: {
                  Authorization: "Bearer " + localStorage.getItem("access_token"),
                }
            };

            try {
                let result = await axios.get(V1API.get_demographic_count, config);
                let response = result.data
                commit('SET_DASHBOARD_DEMOGRAPHIC_COUNT', response.data);
                return response

            } catch(error) {
                commit('SUBMIT_ERROR', true);
            } finally {
                commit('SUBMIT_LOADING', false);
            }
        },
        async fetchContactByShelter ({ commit },payload) {
            commit('SUBMIT_LOADING', true);
            commit('SUBMIT_ERROR', false);

            let config = {
                headers: {
                  Authorization: "Bearer " + localStorage.getItem("access_token"),
                }
            };

            try {
                let result = await axios.get(V1API.get_contact_list_by_shelter +'?shelter='+payload, config);
                let response = result.data
                commit('SET_CONTACT_BY_SHELTER', response.data);
                return response

            } catch(error) {
                commit('SUBMIT_ERROR', true);
            } finally {
                commit('SUBMIT_LOADING', false);
            }
        },

        async fetchDashboardCountByShelter ({ commit },payload) {
            commit('DASHBOARD_COUNT_LOADING', true);
            commit('DASHBOARD_COUNT_ERROR', false);

            let config = {
                headers: {
                  Authorization: "Bearer " + localStorage.getItem("access_token"),
                }
            };

            try {
                let result = await axios.get(V1API.get_dashboard_count_by_shelter + payload.shelter, config);
                let response = result.data
                commit('SET_DASHBOARD_COUNT_SHELTER', response.data);

            } catch(error) {
                commit('DASHBOARD_COUNT_ERROR', true);
            } finally {
                commit('DASHBOARD_COUNT_LOADING', false);
            }
        },
        async fetchDashboardDemographicCountByShelter ({ commit },payload) {
            commit('SUBMIT_LOADING', true);
            commit('SUBMIT_ERROR', false);

            let config = {
                headers: {
                  Authorization: "Bearer " + localStorage.getItem("access_token"),
                }
            };

            try {
                let result = await axios.get(V1API.get_demographic_count_by_shelter + payload, config);
                let response = result.data
                commit('SET_DASHBOARD_DEMOGRAPHIC_COUNT_BY_SHELTER', response.data);
                return response

            } catch(error) {
                commit('SUBMIT_ERROR', true);
            } finally {
                commit('SUBMIT_LOADING', false);
            }
        },

        async fetchDashboardCountByShelterLiveTracking ({ commit },payload) {
            commit('DASHBOARD_COUNT_LOADING', true);
            commit('DASHBOARD_COUNT_ERROR', false);

            let config = {
                headers: {
                  Authorization: "Bearer " + localStorage.getItem("access_token"),
                }
            };
            
            try {
                let result = await axios.get(V1API.get_dashboard_count_by_shelter_live +'?shelter=' + payload.shelter+ '&current_date=' + payload.date , config);
                let response = result.data
                commit('SET_DASHBOARD_COUNT_SHELTER_LIVE', response.data);
                return response

            } catch(error) {
                commit('DASHBOARD_COUNT_ERROR', true);
            } finally {
                commit('DASHBOARD_COUNT_LOADING', false);
            }
        },

        async fetchDashboardDemographicCountByShelterLive ({ commit },payload) {
            commit('SUBMIT_LOADING', true);
            commit('SUBMIT_ERROR', false);

            let config = {
                headers: {
                  Authorization: "Bearer " + localStorage.getItem("access_token"),
                }
            };

            try {
                let result = await axios.get(V1API.get_demographic_count_by_shelter_live +'?shelter=' + payload.shelter+ '&current_date=' + payload.date, config);
                let response = result.data
                commit('SET_DASHBOARD_DEMOGRAPHIC_COUNT_BY_SHELTER_LIVE', response.data);
                return response

            } catch(error) {
                commit('SUBMIT_ERROR', true);
            } finally {
                commit('SUBMIT_LOADING', false);
            }
        },
  
      

    },

    getters: {}
}
